import { Button } from '@mui/material';

import GenericDialog from 'portal/src/components/common/GenericDialog';
import { FormCard } from 'portal/src/components/common/forms/FormCard';

import AllocationLineItems from './AllocationLineItems';
import AllocationLineItemsDialogMessage from './AllocationLineItemsDialogMessage';

import { useBillFormContext } from '../BillFormContext';

export default function EditAllocationLineItemsDialog({
  onClose,
  onSave,
  open,
}: {
  onClose: () => void;
  onSave: () => void;
  open: boolean;
}): JSX.Element {
  const { allocatedLineItemMappings, resetAllocationLineItems } =
    useBillFormContext();

  const allocationTotalsDoNotMatchLineItem =
    allocatedLineItemMappings.data.some(
      (m) => m.costDifference !== 0 || m.usageDifference !== 0,
    );

  const handleClose = () => {
    resetAllocationLineItems();
    onClose();
  };

  return (
    <GenericDialog
      dialogActions={
        <>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            color="secondary"
            disabled={allocationTotalsDoNotMatchLineItem}
            variant="contained"
            disableElevation
            onClick={() => {
              onSave();
            }}
          >
            Update allocations
          </Button>
        </>
      }
      maxWidth={'xxl'}
      open={open}
      onClose={handleClose}
      title="Edit Allocation Line Item Details"
    >
      <FormCard showContentDivider={false}>
        <AllocationLineItems
          disabled={allocationTotalsDoNotMatchLineItem}
          editable
        />
      </FormCard>
      {allocationTotalsDoNotMatchLineItem && (
        <AllocationLineItemsDialogMessage message="Unable to update allocations because some of the allocation line item totals do not match the master line item." />
      )}
    </GenericDialog>
  );
}
